import fetch from '../utils/fetch';

export function allFormula(params) {
  return fetch({
    method: 'GET',
    url: '/formula/allFormula',
    params
  })
}

export function deleteFormula(params) {
  return fetch({
    method: 'POST',
    url: "/formula/deleteFormula",
    data:params
  })
}

export function formulaListByPage(params) {
  return fetch({
    method: 'GET',
    url: '/formula/formulaListByPage',
    params
  })
}

export function saveFormula(params) {
  return fetch({
    method: 'POST',
    url: "/formula/saveFormula",
    data:params
  })
}

///formula/updateFormula
export function updateFormula(params) {
  return fetch({
    method: 'POST',
    url: "/formula/updateFormula",
    data:params
  })
}

///formula/detail
export function detail(params) {
  return fetch({
    method: 'GET',
    url: "/formula/detail",
    params
  })
}